/**
 * Iglesia IEVI - JS Orchestrator (Islands Architecture)
 * Este archivo se encarga de cargar los componentes solo si existen en el DOM
 * y solo cuando son necesarios (scroll/idle).
 */

const ComponentLoader = {
    // Configuración de componentes y sus selectores
    islands: [
        {
            name: 'home-hero',
            selector: '.splide', // El selector que usa el hero
            loadType: 'visible', // Cargar solo cuando sea visible
            path: './home-hero.js',
        },
        {
            name: 'ajax-search',
            selector: '#search-overlay',
            loadType: 'idle', // Cargar en tiempo de inactividad
            path: './ajax-search.js',
        },
        {
            name: 'header',
            selector: 'header',
            loadType: 'immediate',
            path: './header.js',
        },
        {
            name: 'lightbox',
            selector: '.ievi-gallery-item',
            loadType: 'visible',
            path: './lightbox.js',
        },
        {
            name: 'countdown',
            selector: '#featured-countdown-container',
            loadType: 'visible',
            path: './featured-countdown.js',
        },
    ],

    init() {
        this.islands.forEach((island) => {
            const element = document.querySelector(island.selector);
            if (!element) return;

            switch (island.loadType) {
                case 'visible':
                    this.loadOnVisible(element, island.path);
                    break;
                case 'idle':
                    this.loadOnIdle(island.path);
                    break;
                default:
                    this.loadImmediately(island.path);
            }
        });
    },

    /**
     * Carga el módulo cuando el elemento entra en el viewport
     */
    loadOnVisible(element, path) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.importModule(path);
                        observer.unobserve(element);
                    }
                });
            },
            { rootMargin: '100px' }
        ); // Margen para empezar a cargar antes de que sea visible

        observer.observe(element);
    },

    /**
     * Carga el módulo en tiempo de inactividad
     */
    loadOnIdle(path) {
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(() => this.importModule(path));
        } else {
            setTimeout(() => this.importModule(path), 2000);
        }
    },

    loadImmediately(path) {
        this.importModule(path);
    },

    async importModule(path) {
        try {
            const module = await import(path);
            if (module.default && typeof module.default === 'function') {
                module.default();
            }
        } catch (err) {
            console.error(`Error cargando el módulo ${path}:`, err);
        }
    },
};

// Arrancar el orquestador cuando el DOM esté listo
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ComponentLoader.init());
} else {
    ComponentLoader.init();
}
